<template>
	<div class="create-sync-group-connection px-2">
		<div class="selection flex-column pb-2">
			<div class="app pb-4">
				<div>Choose app</div>
				<AppSelect class="select" outlined dense v-model="appSelected" :items="appItems" item-text="service_name" return-object>
					<template v-slot:selection="{ item }">
						<div class="selected-app flex-centerize">
							<IntegrationIcon :integrationName="item.service_slug" :size="serviceIconWidth" :padding="serviceIconPadding" />
							<div class="integration-name">{{ item.service_name }}</div>
						</div>
					</template>
					<template v-slot:item="{ item }">
						<div class="selection-row flex-centerize">
							<IntegrationIcon :integrationName="item.service_slug" :size="serviceIconWidth" :padding="serviceIconPadding" />
							<div class="integration-name">{{ item.service_name }}</div>
						</div>
					</template>
				</AppSelect>
			</div>
			<div class="profile" v-if="appSelected">
				<div>Connect an account</div>
				<ProfileSelector
					:serviceId="appSelected.id"
					:serviceVersionId="appSelected.version"
					@select-profile="selectAccountConnection"
					:profileId="profileSelectedId"
					v-if="appSelected"
					:shouldOpenProjectOptions="false"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import { getAllServices, getService } from '@/store/modules/apps/getters';
import { groups } from '@/store/modules/accountGroups/getters';
import ProfileSelector from '@/components/common/ProfileSelector';
import { ServiceType } from '@ply-io/ply-front-shared-utilities';
export default {
	name: 'SyncedGroupConnection',
	components: {
		ProfileSelector,
	},
	props: {
		group: { type: Object, default: null },
	},
	computed: {
		...mapGetters([getAllServices.fullPath, groups.fullPath, getService.fullPath]),
		canGoNext() {
			return this.appSelected && this.profileSelectedId;
		},
		defaultServiceId() {
			return this.group?.synced?.service;
		},
		appItems() {
			if (this.defaultServiceId) {
				return [this[getService.fullPath](this.defaultServiceId)];
			}
			return Object.values(this[getAllServices.fullPath]).filter((x) => x.type === ServiceType.Integration && x.user_matching_enabled);
		},
		syncedServices() {
			return this[groups.fullPath].filter((x) => x.synced).map((x) => x.synced.service);
		},
		title() {
			return this.isUpdate ? 'Update synced group' : 'New synced group';
		},
	},
	methods: {
		selectAccountConnection(accountConnectionId) {
			this.profileSelectedId = accountConnectionId;
			this.$emit('selected-connection-id', this.profileSelectedId);
		},
	},
	async mounted() {
		if (this.group) {
			this.profileSelectedId = this.group.synced?.credentials;
			if (this.defaultServiceId) {
				this.appSelected = this.appItems.find((x) => (x.id = this.defaultServiceId));
			} else {
				this.appSelected = undefined;
			}
		}
	},
	watch: {
		appSelected: {
			handler(newV) {
				newV && this.$emit('selected-app', newV);
			},
			immediate: true,
		},
	},
	data() {
		return {
			appSelected: undefined,
			profileSelectedId: undefined,
			serviceIconWidth: 30,
			serviceIconPadding: 10,
		};
	},
};
</script>

<style scoped lang="scss">
.create-sync-group-connection {
	.title {
		font-weight: 600;
		font-size: x-large;
	}
	.sub-title {
		font-size: small;
	}
	.selection {
		font-size: 12px;
		.select,
		.profile {
			width: 500px;
		}
	}
}
.integration-name {
	padding: 10px;
}
</style>
